import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import themeColors from '../../assets/styles/themeColors';
import RetirementBusinessNameForm from '../../components/Forms/RetirementBusinessNameForm';
import { HeadingSubtitle } from '../../components/Heading';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';

import { useMenu } from '../../hooks/useMenu';
import { selectSettings } from '../../store/selectors/settingsSelectors';

const SecureAccountRetirementBusinessName = () => {
  const { t } = useTranslation();
  const { activeMenu, activeItem } = useMenu();
  const { BrokerName } = useSelector(selectSettings);
  const formId = 'business_name_form';
  const [eventType, setEventType] = useState(null);

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeItem={activeItem}
      previousPath={activeItem?.previousPath}
      formId={formId}
      setEventType={setEventType}
    >
      <Helmet>
        <title>
          {t('titleTagBusinessName', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <HeadingSubtitle mb={32} color={themeColors.colorTextSecondary}>
        {t('retirementBusinessName.title')}
      </HeadingSubtitle>
      <RetirementBusinessNameForm
        nextPath={activeItem?.nextPath}
        formId={formId}
        setEventType={setEventType}
        eventType={eventType}
      />
    </OnBoardingContainer>
  );
};

export default SecureAccountRetirementBusinessName;
